import React from "react";
import assetify from "@quintype/framework/assetify";

import DefaultDesktopLogo from "../../../../assets/images/muktijuddho.svg";

import "./desktopLogo.m.css";

const DesktopLogo = () => {
  const renderLogo = () => {
    return (
      <img
        src={`${assetify(DefaultDesktopLogo)}`}
        alt="চিরন্তন ১৯৭১ প্রথম আলো"
        styleName="palo-logo"
        data-tracking-category="Eternal 1971  Logo"
        data-tracking-action="Click"
        data-tracking-label="চিরন্তন ১৯৭১ লোগো"
      />
    );
  };
  return <h2 className="desktop-logo"><span styleName="beta">Beta</span>{renderLogo()}</h2>;
};

export default DesktopLogo;
